import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@fortawesome/fontawesome-free/css/all.min.css';

import AOS from 'aos'
import 'aos/dist/aos.css' // AOS 样式

import devicePlugin from "@/utils/device";

Vue.use(devicePlugin);

Vue.use(ElementUI)
// 初始化 AOS
Vue.prototype.$aos = AOS.init({
    duration: 800,       // 动画持续时间（ms）
    easing: 'ease-in-out', // 缓动函数
    once: true,          // 动画只触发一次
    offset: 100,         // 触发距离（元素距离视口底部 100px 时触发）
    disable: function () {
        return false;
        // const isMobile = window.innerWidth < 768;
        // if (isMobile) {
        //     // 动态添加移动端样式
        //     const style = document.createElement('style');
        //     style.innerHTML = `
        //         [data-aos] {
        //           opacity: 1 !important;
        //           transform: none !important;
        //         }
        //       `;
        //     document.head.appendChild(style);
        // }
        // return isMobile;
    }
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
